import { ParecerAnaliseDocumentalFooterComponent } from '../recurso-profissional/parecer-analise-documental/parecer-analise-documental-footer.component';

export const DESLIGAMENTO_PDF_HEADER_FOOTER_STYLES = `
  .document-header {
    flex: 0 0 auto;
    min-height: 159px;
    background: #ffffff;
  }
  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 84px;
    padding: 14px 28px;
    background: #F9FAFB;
  }
  .government {
    margin: 0 0 2px;
    color: #222222;
    font-size: 9.5px;
    line-height: 14.25px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    text-align: left;
  }
  .platform {
    margin: 0;
    color: #222222;
    font-size: 15px;
    line-height: 17.55px;
    letter-spacing: 0.3px;
    font-weight: 700;
    text-align: left;
  }
  .header-stripe {
    height: 4px;
    background: linear-gradient(90deg, #183eff 0%, #4fc3f7 37.98%, #ffcf00 68.75%, #0055a1 97.6%);
  }
  .header-title-box {
    padding: 14px 28px 2px;
    background: #ffffff;
  }
  .header-title-box h1 {
    margin: 0 0 4px;
    color: #1A5276;
    font-size: 17px;
    line-height: 21.25px;
    font-weight: 700;
    text-align: left;
    letter-spacing: 0;
    text-transform: none;
  }
  .header-title-box p {
    margin: 0;
    color: #555555;
    font-size: 11px;
    line-height: 15.4px;
    text-align: left;
  }
  .document-footer {
    flex: 0 0 auto;
    width: 100%;
    background: #ffffff;
    margin-top: 20px;
  }
  .footer-note {
    margin: 0 28px;
    padding: 11px 0 10px;
    border-top: 1px dashed #CCCCCC;
    color: #999999;
    font-size: 8px;
    line-height: 13.6px;
    text-align: center;
    min-height: 38px;
  }
  .footer-stripe {
    height: 4px;
    background: #0F8EED;
  }
  .footer-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 7px 28px;
    background: #1A5276;
    color: rgba(255,255,255,0.7);
    font-size: 9px;
    line-height: 13.5px;
  }
  .footer-bar strong {
    color: #ffffff;
    font-weight: 700;
    flex: 0 0 auto;
  }
`;

export class DesligamentoPdfLayout {
  static montarCabecalho(titulo: string, subtitulo: string): string {
    return `
    <header class="document-header">
      <div class="header-top">
        <div>
          <p class="government">Ministério da Saúde | AGSUS</p>
          <p class="platform">Plataforma de Gerenciamento de Programas de Provimento | PGP</p>
        </div>
      </div>
      <div class="header-stripe"></div>
      <div class="header-title-box">
        <h1>${this.escapeHtml(titulo)}</h1>
        <p>${this.escapeHtml(subtitulo)}</p>
      </div>
    </header>`;
  }

  static montarRodape(pagina = '1', totalPaginas = '1'): string {
    return ParecerAnaliseDocumentalFooterComponent.montarHtml(pagina, totalPaginas);
  }

  private static escapeHtml(value: unknown): string {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}
